import { connect } from 'react-redux';
import { beginDeviationAwardBadgeFlow } from '../../../coreBadge/redux/actionCreators';
import { getLimitedBadgesPromo } from '../../../publicSession/selectors';
const mapStateToProps = (state)=>({
        limitedBadgesPromo: getLimitedBadgesPromo(state)
    });
const mapDispatchToProps = {
    onAwardClick: beginDeviationAwardBadgeFlow
};
export default connect(mapStateToProps, mapDispatchToProps);
